export default __webpack_public_path__ + "dc2b5d66e24b9c80a85a8b5ed87e19fb.png";